module.exports = __webpack_public_path__ + "media/Team/Group2-a1b504c5.svg";